import React from 'react'
import { Link } from 'react-router-dom'
import PDFViewer from '../utility/PDFViewer'

const StudentSolutions = ({ solutions }) => {
    return (
        <div className='mt-3'>
            <table>
                <thead>
                    <tr>
                        <td>Name</td>
                        <td>View</td>
                    </tr>
                </thead>
                {
                    solutions.map((s, i) =>
                        <tbody>
                            <tr>
                                <td>{s.examName}</td>
                                <td>
                                    <Link
                                        to={{
                                            pathname: '/view-solution',
                                            // search: `?fileUrl=${encodeURIComponent(`${process.env.REACT_APP_API_URL}${s.fileUrl}`)}`
                                            search: `?fileUrl=${`${s.fileUrl}`}`
                                        }}
                                    >
                                        <button className="btn btn-sm">View</button>
                                    </Link>
                                </td>
                            </tr>
                        </tbody>
                    )
                }
            </table>
        </div>
    )
}

export default StudentSolutions
